import React from "react";

export const Transaction = ({ width = "20px", height = "20px" }) => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.6875 14.5625L14.2933 6.11956C14.9946 5.43148 15.3453 5.08744 15.6478 5.21298C15.9502 5.33851 15.9556 5.83031 15.9663 6.81387L16 9.91803" stroke="#7D7575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.3125 1.4375L2.70677 9.88044C2.00541 10.5686 1.65474 10.9125 1.35225 10.787C1.04974 10.6615 1.0444 10.1697 1.03372 9.18612L1 6.08201" stroke="#7D7575" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);
